export interface UniswapV2ProviderConfiguration {
    readonly maxTransitTokens: number;
    readonly routingProvidersAddresses: string[];
    readonly wethAddress: string;
}
